import { createFileRoute } from '@tanstack/react-router';

import {
  analyticsSearchSchema,
  resolveAnalyticsRange,
  SocialAnalyticsPage,
  socialAnalyticsQueryOptions,
  socialAnalyticsToday,
} from '@/features/social';

/** Four tiles, one chart, top products over the last 7, 28 or 90 days. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/social/pinterest/analytics')({
  staticData: { crumb: 'social:analytics.title' },
  validateSearch: analyticsSearchSchema,
  loaderDeps: ({ search }) => ({ days: search.days }),
  loader: ({ context, params, deps }) =>
    context.queryClient
      .query({
        ...socialAnalyticsQueryOptions(
          params.storeId,
          resolveAnalyticsRange(deps, socialAnalyticsToday(context.store.timezone)),
        ),
        staleTime: 'static',
      })
      .catch(() => undefined),
  component: SocialAnalyticsRoute,
});

function SocialAnalyticsRoute() {
  const { days } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <SocialAnalyticsPage
      range={days}
      onRangeChange={(next) => void navigate({ search: { days: next }, replace: true })}
    />
  );
}
